import {getInfo, logout, getUserExtInfo} from '@/api/user';
import {getSecLimit} from '@/api/my';
import jwtDecode from 'jwt-decode';
import {removeToken, getToken} from '@/utils/auth';
import {connect, unconnect} from '@/utils/mqttUtils';

const state = {
    userToken: null,
    userInfo: null,
    userExtInfo: null,
    userLimit: null,
};

const mutations = {
    SETUSERTOKEN: (state, token) => {
        console.log(token);
        state.userToken = token;
    },
    SETUSERINFO: (state, info) => {
        console.log('info', info);
        state.userInfo = info;
    },
    SETUSEREXTINFO: (state, info) => {
        state.userExtInfo = info;
    },
    SETSECLIMIT: (state, info) => {
        state.userLimit = info;
    },
};

const actions = {
    GetInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            let userId = jwtDecode(getToken()).user_id;
            getInfo({userid: userId})
                .then((res) => {
                    const user = res.data;
                    console.log('-----userinro', JSON.parse(JSON.stringify(user)));
                    connect(userId);
                    commit('SETUSERINFO', user);
                    localStorage.setItem('ac', user?.account)
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
            getUserExtInfo({userid: userId})
                .then((res) => {
                    console.log('userextinfo', JSON.parse(JSON.stringify(res.data)));
                    commit('SETUSEREXTINFO', res.data);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
            getSecLimit({})
                .then((res) => {
                    console.log('免密金额', res.data);
                    commit('SETSECLIMIT', res.data);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 刷新token
    RefreshToken({commit, state}) {
        return new Promise((resolve, reject) => {
            refreshToken(state.token)
                .then((res) => {
                    setExpiresIn(res.data);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 退出系统
    LogOut({commit, state}) {
        return new Promise((resolve, reject) => {
            logout(state.token)
                .then(() => {
                    commit('SETUSERTOKEN', '');
                    commit('SETUSERINFO', '');
                    removeToken();
                    resolve();
                    unconnect();
                    window.location.reload();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    mutations,
    actions,
};
